import React from 'react';
import { Link } from 'react-router-dom';
import { FYLKER } from './LocationSelector';

const ProfileCard = ({ user, compact = false }) => {
  const fylke = FYLKER.find(f => f.id === user.location_fylke);
  
  // Beregn gjennomsnittlig rating
  const avgRating = user.reviews?.length 
    ? (user.reviews.reduce((sum, r) => sum + r.rating, 0) / user.reviews.length).toFixed(1)
    : null;

  if (compact) {
    return (
      <Link 
        to={`/profil/${user.id}`}
        className="flex items-center gap-3 p-3 bg-white rounded-lg hover:bg-slate-50 transition-colors"
      >
        {/* Avatar */}
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1E3A5F] to-[#0A1929] flex items-center justify-center overflow-hidden flex-shrink-0">
          {user.profile_image ? (
            <img src={user.profile_image.startsWith('http') ? user.profile_image : `${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${user.profile_image}`} alt={user.name} className="w-full h-full object-cover" />
          ) : (
            <span className="text-white font-bold text-lg">
              {user.name?.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        <div className="flex-grow min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-medium text-[#0A1929] truncate">{user.name}</span>
            {user.is_verified && (
              <span className="material-symbols-outlined text-green-500 text-lg" title="Verifisert">
                verified
              </span>
            )}
          </div>
          {avgRating && (
            <div className="flex items-center gap-1 text-sm text-slate-500">
              <span className="material-symbols-outlined text-yellow-500 text-sm">star</span>
              <span>{avgRating}</span>
              <span>({user.reviews?.length} vurderinger)</span>
            </div>
          )}
        </div>
      </Link>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6">
      {/* Header med avatar */}
      <div className="flex flex-col items-center text-center mb-6">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#1E3A5F] to-[#0A1929] flex items-center justify-center overflow-hidden mb-4">
          {user.profile_image ? (
            <img src={user.profile_image.startsWith('http') ? user.profile_image : `${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${user.profile_image}`} alt={user.name} className="w-full h-full object-cover" />
          ) : (
            <span className="text-white font-bold text-3xl">
              {user.name?.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        <div className="flex items-center gap-2 mb-2">
          <h2 className="font-heading font-bold text-xl text-[#0A1929]">{user.name}</h2>
          {user.is_verified && (
            <span className="material-symbols-outlined text-green-500" title="Verifisert bruker">
              verified
            </span>
          )}
        </div>

        {/* Rating */}
        {avgRating && (
          <div className="flex items-center gap-1 text-slate-600 mb-2">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((star) => (
                <span 
                  key={star}
                  className={`material-symbols-outlined text-lg ${
                    star <= Math.round(avgRating) ? 'text-yellow-500' : 'text-slate-300'
                  }`}
                >
                  star
                </span>
              ))}
            </div>
            <span className="font-medium">{avgRating}</span>
            <span className="text-sm">({user.reviews?.length} vurderinger)</span>
          </div>
        )}

        {/* Lokasjon */}
        {fylke && (
          <div className="flex items-center gap-1 text-slate-500 text-sm">
            <span className="material-symbols-outlined text-lg">location_on</span>
            {fylke.name}
          </div>
        )}
      </div>

      {/* Kontaktinfo - ikke vist automatisk, kun via "Vis kontaktinfo" knapp */}

      {/* Statistikk */}
      {user.completed_jobs !== undefined && (
        <div className="flex justify-around mt-6 pt-4 border-t border-slate-100">
          <div className="text-center">
            <div className="font-heading font-bold text-2xl text-[#0A1929]">
              {user.completed_jobs || 0}
            </div>
            <div className="text-xs text-slate-500">Fullførte oppdrag</div>
          </div>
          <div className="text-center">
            <div className="font-heading font-bold text-2xl text-[#0A1929]">
              {user.reviews?.length || 0}
            </div>
            <div className="text-xs text-slate-500">Vurderinger</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
